<template>
  <div>
    <div class='pt-2 altura-250 tab-ficha'>
      <div class='d-flex align-center'>
        <!-- <img
          class='btn-generico'
          :src='require("@/assets/images/Btn-arrowLeft.gif")'
          :alt="$t('lang.comun.anterior')"
         
        /> -->
        <div class="col-sm-1 col-md-1">
          <button type="button"  class="vuecal__arrow vuecal__arrow--prev" @click='restarMes()'>
            <i alt="Anterior" class="angle"></i>
          </button>
        </div>
        <div class="d-flex align-center">
          <div class="titulo-mes"> {{ month + ' ' + year }}</div>
          <v-btn type="button" class="primary" @click="irHoy">HOY</v-btn>
        </div>
        <div class="text-left col-sm-1 col-md-1">
          <button type="button" aria-label="Next month" class="float-right vuecal__arrow vuecal__arrow--next" @click='sumarMes()'>&nbsp;<i class="angle"></i>&nbsp;</button>
        </div>
        <!-- <img
          class='btn-generico'
          :src='require("@/assets/images/Btn-arrowRight.gif")'
          :alt="$t('lang.comun.anterior')"
          @click='sumarMes()'
        /> -->
      </div>
      <!-- Calendario -->
      <div class='calendario-body mt-2 noselect'>
        <div class="calendario-semana">
            <strong class='calendario-dia-semana' v-for='day in days' :key='day'>{{ day }}</strong>
        </div>
        <div class='calendario-dias'>
          <div class='calendario-dias-fila' v-for='semana in calendario' :key='semana.indiceSemana'>
            <div
              class='calendario-dias-fila-celda pointer'
              v-for='dia in semana.diasSemana'
              :key='dia.diaNumber'
              :class='{ deshabilitado : dia.diaTipo === 0, findesemana: dia.diaTipo === 2, vacaciones: dia.diaTipo === 3, 
              festivootros: dia.tipoFestivo === 4, festivolocal: dia.tipoFestivo === 3, festivoregional: dia.tipoFestivo ===2, festivonacional: dia.tipoFestivo ===1, hoy : dia.hoy }'
              @click='modificarCalendario (dia.fecha, dia.diaTipo, dia.msvacacionid)'
            >
              <div class='calendario-dias-fila-celda-dia'>
                {{ dia.diaNumber }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- FIN. Calendario -->
      <!-- Leyenda del calendario -->
      <div class='py-2 d-flex align-center'>
        <div class="pr-15"><span>Total vacaciones {{ this.totalVacaciones }}</span></div>
        <div class='cuadrado-20 hoy'/>&nbsp;<small>{{ leyenda.hoy }}&nbsp;</small>
        <!-- <div class='cuadrado-20 festivo'/>&nbsp;<small>{{ leyenda.festivo }}&nbsp;</small> -->
        &nbsp;<div class='cuadrado-20 vacaciones'/>&nbsp;<small>{{ leyenda.vacaciones }}&nbsp;</small>
        <div class="cuadrado-20 festivonacional"></div>&nbsp;<small>Festivo nacional&nbsp;</small>
        <div class="cuadrado-20 festivoregional"></div>&nbsp;<small>Festivo regional&nbsp;</small>
        <div class="cuadrado-20 festivolocal"></div>&nbsp;<small>Festivo local&nbsp;</small>
        <div class="cuadrado-20 festivootros"></div>&nbsp;<small>Festivo otros&nbsp;</small>
      </div>
      <!-- FIN. Leyenda del calendario -->
    </div>
  </div>
</template>
<script>
import { VacacionApiService } from '@/api/VacacionApiService'
import { CalenlabApiService } from '@/api/CalenlabApiService'
import { Util } from '@/api/Util'

const vacacionApiService = new VacacionApiService()
const calenlabApiService = new CalenlabApiService()
const util = new Util()
const moment = require('moment')

export default {
  data () {
    return {
      today: moment(),
      dateContext: moment(),
      lang: sessionStorage.getItem('lang'),
      vacacion: [],
      calendarioLaboral: [],
      opuid: this.$store.getters.getOpuid,
      days: [
        this.$t('lang.calendario.lun'),
        this.$t('lang.calendario.mar'),
        this.$t('lang.calendario.mie'),
        this.$t('lang.calendario.jue'),
        this.$t('lang.calendario.vie'),
        this.$t('lang.calendario.sab'),
        this.$t('lang.calendario.dom')
      ],
      leyenda: {
        hoy: this.$t('lang.comun.hoy'),
        festivo: this.$t('lang.comun.festivo'),
        vacaciones: this.$t('lang.comun.vacaciones')
      },
      totalVacaciones: 0
    }
  },
  props: {
    personaParam: Object,
    tabSeleccionado: Number
  },
  created () {
    this.init()
  },
  watch: {
    personaParam: {
      handler (n, o) {
        if (n.mspersonaid !== o.mspersonaid) {
          this.reset(n)
        }
      },
      deep: true
    },
    year: {
      handler (n, o) {
        if (n !== o) {
          // Cargamos el calendario laboral de ese anho
          this.getDiatrabajoByAnhoAndOpuid()
        }
      },
      deep: true
    },
    mes: {
      handler (n, o) {
        if (n !== o) {
          // Cargamos el calendario laboral de ese anho
          this.getVacacionByMonthYearAndPersonaId()
        }
      },
      deep: true
    }
  },
  methods: {
    init () {
      moment.locale(this.lang)
      this.today = moment()
      this.dateContext = moment()
      this.getVacacionByMonthYearAndPersonaId()
      // if (sessionStorage.getItem('opUid')) {
      //   // Parseamos la persona almacenada en session
      //   this.opuid = sessionStorage.getItem('opUid')
      // }
      this.getDiatrabajoByAnhoAndOpuid()
      this.getCountVacacionByYearAndPersonaId()
    },
    reset () {
      this.today = moment()
      this.dateContext = moment()
      this.getVacacionByMonthYearAndPersonaId()
      this.getCountVacacionByYearAndPersonaId()
    },
    sumarMes: function () {
      this.dateContext = moment(this.dateContext).add(1, 'month')
      this.getCountVacacionByYearAndPersonaId()
    },
    restarMes: function () {
      this.dateContext = moment(this.dateContext).subtract(1, 'month')
      this.getCountVacacionByYearAndPersonaId()
    },
    irHoy () {
       this.dateContext = moment(this.dateContext).set('month', moment().month())
    },
    getCountVacacionByYearAndPersonaId() {
      if (this.personaParam) {
        vacacionApiService.getCountVacacionByYearAndPersonaId({ msvacacionfecha: this.dateContext, persona: { mspersonaid: this.personaParam.mspersonaid }})
          .then(data => {
            util.mostrarEnConsola('PersonasTabVacaciones - getCountVacacionByYearAndPersonaId', data, 'OK')
            this.totalVacaciones = data
          })
          .catch(error => {
            util.mostrarEnConsola('PersonasTabVacaciones - getCountVacacionByYearAndPersonaId', error, 'ERROR')
          })
      }
    },
    getVacacionByMonthYearAndPersonaId () {
      if (this.personaParam) {
        vacacionApiService.getVacacionByMonthYearAndPersonaId(this.mes, this.year, this.personaParam.mspersonaid)
          .then(data => {
            util.mostrarEnConsola('PersonasTabVacaciones - getVacacionByMonthYearAndPersonaId', data.length, 'OK')
            this.vacacion = data
          })
          .catch(error => {
            util.mostrarEnConsola('PersonasTabVacaciones - getVacacionByMonthYearAndPersonaId', error, 'ERROR')
          })
      }
    },
    getDiatrabajoByAnhoAndOpuid () {
      if (this.year && this.opuid) {
        calenlabApiService.getDiatrabajoByAnhoAndOpuid(this.year, this.opuid)
          .then(data => {
            util.mostrarEnConsola('PersonasTabVacaciones - getDiatrabajoByAnhoAndOpuid', data.length, 'OK')
            this.calendarioLaboral = data
          })
          .catch(error => {
            util.mostrarEnConsola('PersonasTabVacaciones - getDiatrabajoByAnhoAndOpuid', error, 'ERROR')
          })
      }
    },
    checkDia: function (dia, mes, anho) {
      var diaObj = {
        diaNumber: null,
        diaStr: '',
        diaTipo: 0,
        msvacacionid: -1,
        tipoFestivo:0
      }
      if (dia && mes && anho) {
        var fecha = moment(dia + '-' + mes + '-' + anho, 'DD-MMM-YYYY')
        diaObj.fecha = fecha
        var tipoFestAux = this.isFestivo(fecha)
        if (this.isVacaciones(fecha) !== -1) { // Comprobamos si tiene vacaciones
          diaObj.diaNumber = dia
          diaObj.diaStr = String(dia)
          diaObj.diaTipo = 3
          diaObj.msvacacionid = this.isVacaciones(fecha)
        } else if (moment(fecha).day() === 0) { // Fin de semana
          diaObj.diaNumber = dia
          diaObj.diaStr = String(dia)
          diaObj.diaTipo = 2
        } else if (tipoFestAux !==0) { // Comprobamos si es festivo
          diaObj.diaNumber = dia
          diaObj.diaStr = String(dia)
          diaObj.diaTipo = 4
          diaObj.tipoFestivo = tipoFestAux
        } else { // Todo lo demas
          diaObj.diaNumber = dia
          diaObj.diaStr = String(dia)
          diaObj.diaTipo = 1
        }
        if (moment(fecha).isSame(new Date(), 'day')) {
          diaObj.hoy = true
        }
      }
      return diaObj
    },
    isVacaciones (fecha) {
      if (this.vacacion.length > 0) {
        for (let i = 0; i < this.vacacion.length; i++) {
          const vacacionItem = this.vacacion[i]
          // Comprobamos si la fecha se encuentra entre la fecha de inicio y fin
          // Se suma y resta 1 a la fecha respectivamente puesto que isBetween es exlusivo
          // console.log('!! ' + fecha + ' ' + moment(vacacionItem.msvacacionfecha, 'YYYY-MM-DD'))
          if (moment(fecha, 'YYYY-MM-DD').isSame(moment(vacacionItem.msvacacionfecha, 'YYYY-MM-DD'))) {
            return vacacionItem.msvacacionid
          }
        }
        return -1
      }
      return -1
    },
    isFestivo (fecha) {
      if (this.calendarioLaboral.length > 0) {
        for (let i = 0; i < this.calendarioLaboral.length; i++) {
          const calendarioLaboralItem = this.calendarioLaboral[i]
          if (moment(fecha).isSame(calendarioLaboralItem.msdiatrabajofecha)) {
            if (calendarioLaboralItem.msdiatrabajotipo === 1 || calendarioLaboralItem.msdiatrabajotipo === 2 || calendarioLaboralItem.msdiatrabajotipo === 3 || calendarioLaboralItem.msdiatrabajotipo === 4) {
              return calendarioLaboralItem.msdiatrabajotipo
            }
          }
        }
        return 0
      }
    },
    modificarCalendario (fecha, diaTipo, msvacacionid) {
      if (diaTipo === 1 || diaTipo === 2 || diaTipo === 4) { // Cualquier dia menos los deshabilitados y las vacaciones
        // Creamos la vacacion
        if (this.personaParam) {
          this.createVacacion(moment(fecha).format('YYYY-MM-DD'), this.personaParam.mspersonaid, this.personaParam.mspersonauid)
        }
      } else if (diaTipo === 3) { // dia vacacional
        // Borramos la vacacion
        if (msvacacionid !== -1) {
          this.deleteVacacion(msvacacionid)
        }
      }
    },
    createVacacion (fecha, mspersonaid, mspersonauid) {
      vacacionApiService.createVacacion(fecha, mspersonaid, mspersonauid, 1)
        .then(data => {
          util.mostrarEnConsola('PersonasTabVacaciones - createVacacion', 'fecha: ' + fecha + ', mspersonauid: ' + mspersonauid + ', mspersonaid: ' + mspersonaid + ', RESPONSE: ' + data, 'OK')
          this.getVacacionByMonthYearAndPersonaId()
          this.getCountVacacionByYearAndPersonaId()
        })
        .catch(error => {
          util.mostrarEnConsola('PersonasTabVacaciones - createVacacion', error, 'ERROR')
        })
    },
    deleteVacacion (msvacacionid) {
      vacacionApiService.deleteVacacion(msvacacionid)
        .then(data => {
          if (data.deleted) {
            util.mostrarEnConsola('PersonasTabVacaciones - deleteVacacion', 'msvacacionid: ' + msvacacionid + ', RESPONSE: ' + data.deleted, 'OK')
            this.getVacacionByMonthYearAndPersonaId()
            this.getCountVacacionByYearAndPersonaId()
          }
        })
        .catch(error => {
          util.mostrarEnConsola('PersonasTabVacaciones - deleteVacacion', error, 'ERROR')
        })
    }
  },
  computed: {
    year: function () {
      return this.dateContext.format('Y')
    },
    mes: function () {
      return this.dateContext.format('MM')
    },
    month: function () {
      return this.dateContext.format('MMMM')
    },
    daysInMonth: function () {
      return this.dateContext.daysInMonth()
    },
    currentDate: function () {
      return this.dateContext.get('date')
    },
    firstDayOfMonth: function () {
      var firstDay = moment(this.dateContext).subtract((this.currentDate - 1), 'days')
      return firstDay.weekday()
    },
    initialDate: function () {
      return this.today.get('date')
    },
    initialMonth: function () {
      return this.today.format('MMMM')
    },
    initialYear: function () {
      return this.today.format('Y')
    },
    weekOfMonth: function () { // Semana con respecto al mes
      return this.dateContext.week() - moment(this.dateContext).startOf('month').week() + 1
    },
    numberOfWeeksOfMonth: function () {
      const dateFirst = moment(this.dateContext).date(1)
      const dateLast = moment(this.dateContext).date(this.dateContext.daysInMonth())
      const startWeek = dateFirst.isoWeek()
      const endWeek = dateLast.isoWeek()
      if (endWeek < startWeek) {
        return (Math.abs(dateFirst.isoWeeksInYear() - startWeek) + endWeek) + 1
      } else {
        return endWeek - startWeek + 1
      }
    },
    calendario: function () {
      const calendario = []
      var d = 1
      for (var semana = 0; semana < this.numberOfWeeksOfMonth; semana++) {
        // Creamos los días de la semana
        if (semana === 0) { // Primera semana
          const semanaArray = {
            indiceSemana: semana,
            diasSemana: []
          }
          for (var x = 0; x < this.firstDayOfMonth; x++) {
            semanaArray.diasSemana.push(this.checkDia(null, this.month, this.year))
          }
          for (var l = this.firstDayOfMonth; l < 7; l++) {
            semanaArray.diasSemana.push(this.checkDia(d, this.month, this.year))
            d++
          }
          calendario.push(semanaArray)
        } else if (semana === this.numberOfWeeksOfMonth - 1) { // Ultima semana
          const semanaArray = {
            indiceSemana: semana,
            diasSemana: []
          }
          for (var i = 0; i < 7; i++) {
            if (d <= this.daysInMonth) {
              semanaArray.diasSemana.push(this.checkDia(d, this.month, this.year))
              d++
            } else {
              semanaArray.diasSemana.push(this.checkDia(null, this.month, this.year))
            }
          }
          calendario.push(semanaArray)
        } else { // Resto de semanas
          const semanaArray = {
            indiceSemana: semana,
            diasSemana: []
          }
          for (let j = 0; j < 7; j++) {
            semanaArray.diasSemana.push(this.checkDia(d, this.month, this.year))
            d++
          }
          calendario.push(semanaArray)
        }
      }
      return calendario
    }
  }
}
</script>
